import React from 'react';

// Components

import FamilyAndHouseholdSummary_NV from '../summary/FamilyAndHouseholdSummary_NV';
import PageHeader from '../../../../../components/ssap/headers/PageHeader';
import SummaryFilter from '../summary/SummaryFilter';

// Types

import { SsapSummaryType } from '../../../../../components/ssap/SsapTypes';


const FamilyAndHouseholdSummary = props => {

    // @ts-ignore
    const summaryId = SsapSummaryType.FAMILY_AND_HOUSEHOLD.processReplacements({ idx: 'ROOT' });

    return (
        <SummaryFilter summaryId = { summaryId } >
            <div className = 'final-review-heading' >
                <PageHeader
                    text = 'common.household_members'
                    headerClassName = 'gi-heading-alt'
                />
            </div>
            <div className = 'final-review-body' >
                <FamilyAndHouseholdSummary_NV
                    { ...props }
                />
            </div>
        </SummaryFilter>
    );
};

export default FamilyAndHouseholdSummary;